import guild from "@/assets/local-area/guild.svg";
import gavel from "@/assets/local-area/gavel.svg";
import finance from "@/assets/local-area/finance.svg";
import business from "@/assets/local-area/business.svg";

const marker = (key, coordinates, icon, hasPopup = false, offset = [0, 0]) =>
  hasPopup
    ? (title, address, link = null) => ({
        key,
        coordinates,
        icon,
        offset,
        hasPopup,
        popup: {
          title,
          address,
          link
        }
      })
    : { key, coordinates, icon, offset, hasPopup };

export default [
  // Legal
  marker("district court", [-117.1659483, 32.7156363], gavel, true)(
    "U.S. District Court Southern District of California",
    "333 W Broadway #420"
  ),
  marker("sd da", [-117.1660547, 32.7158398], gavel, true)(
    "san diego district attorney",
    "330 W Broadway #1300"
  ),
  marker("sd courthouse", [-117.166241, 32.717519], gavel, true)(
    "San Diego Central Courthouse",
    "1100 Union St"
  ),
  marker("edward building", [-117.165155, 32.714142], gavel, true)(
    "Edward J. Schwartz Federal Building",
    "880 Front St"
  ),
  // Finance
  marker("boa", [-117.1688099, 32.7155654], finance, true)(
    "Bank of America",
    "655 W Broadway STE 101"
  ),
  marker("us bank", [-117.1686646, 32.71631], finance, true)(
    "US Bank",
    "600 W Broadway STE 100"
  ),
  marker("mission fcu", [-117.168561, 32.719639], finance, true)(
    "Mission Federal Credit Union",
    "1370 India St"
  ),
  marker("chase", [-117.1681761, 32.720114], finance, true)(
    "Chase Bank",
    "1415 India S"
  ),
  marker("tp bank", [-117.1678362, 32.7167949], finance, true)(
    "Torrey Pines Bank",
    "550 West C St STE 100"
  ),
  marker("cn bank", [-117.167737, 32.715179], finance, true)(
    "City National Bank",
    "501 W Broadway #100"
  ),
  marker("pw bank", [-117.164296, 32.719411], finance, true)(
    "Pacific Western Bank",
    "110 West A St Suite 100"
  ),
  // Business
  marker("morgan", [-117.164268, 32.7150418], business, true)(
    "Morgan Stanley",
    "101 W Broadway STE 1800"
  ),
  marker("deloitte", [-117.1688099, 32.7155654], business, true)(
    "Deloitte",
    "655 W Broadway Suite 700"
  ),
  marker("gd", [-117.185302, 32.7289004], business, true)(
    "General Dynamics",
    "2798 Harbor Dr"
  ),
  // The Guild
  marker("the guild", [-117.1677154, 32.716004], guild, true, [0, -45])(
    "the guild",
    "500 W Broadway",
    "https://theguildhotel.com/"
  )
];
